module.exports = __webpack_public_path__ + "assets/img/4.028f593a.png";